// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".p2p-page .MuiTable-root th,\n.p2p-page .MuiTable-root td {\n  border-bottom: 1px solid #E5E5E5;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/p2p/P2p.less"],"names":[],"mappings":"AAAA;;EAEI,gCAAA;AACJ","sourcesContent":[".p2p-page {\n  .MuiTable-root th, .MuiTable-root td {\n    border-bottom: 1px solid #E5E5E5;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
